import { render } from "./OnDisplaySection.vue?vue&type=template&id=1e9c1b50&scoped=true&ts=true"
import script from "./OnDisplaySection.vue?vue&type=script&lang=ts"
export * from "./OnDisplaySection.vue?vue&type=script&lang=ts"

import "./OnDisplaySection.vue?vue&type=style&index=0&id=1e9c1b50&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9c1b50"]])

export default __exports__